<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import TasksTable from './TasksTable';

export default {
  page: {
    title: 'Tasks',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, TasksTable },
  data() {
    return {
      title: 'Tasks',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Tasks', active: true, },
      ],

      loading: true,
    }
  },
  created() {
    
  },
  methods: {
    
  }
}
</script>

<template>
  <Layout>
    <router-view v-show="$route.params.id" :key="$route.fullPath"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
        <div class="col-12">
          <div class="card-box p-0 position-relative">
            <TasksTable ref="TasksTable" @loadchange="(e) => {loading = e;}"></TasksTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
